package org.vreo.devicehub.features.userAuthentication.presentation.register

import org.vreo.devicehub.features.core.presentation.UiText

data class UserRegistrationState(
    val isLoading: Boolean = false,
    val error: UiText? = null,

    val invalidEmail: Boolean = false,
    val invalidPassword: Boolean = false,
    val passwordMinimumLengthCheck: Boolean = false,
    val passwordUppercaseCheck: Boolean = false,
    val passwordLowercaseCheck: Boolean = false,
    val passwordNumberCheck: Boolean = false,
    val invalidConfirmPassword: Boolean = false,

    val invalidFirstName: Boolean = false,
    val invalidLastName: Boolean = false,
    val invalidCompanyName: Boolean = false,

    // User details
    val email: String = "",
    val password: String = "",
    val confirmPassword: String = "",
    val firstName: String = "",
    val lastName: String = "",
    val mobileNumber: String = "",

    // Company details
    val companyName: String = "",
    val companyAddressStreet: String = "",
    val companyAddressCity: String = "",
    val companyAddressPostalCode: String = "",
    val companyAddressCountry: String = "",
)